import { jsx } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/react/jsx-runtime.es.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.es.es.js";
import "react";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.es.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.es.es.js";
import "@mui/material";
import { AngleDownSmallOutlined as i } from "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/outlined/angle-down-small-outlined.es.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/turn-icons.es.es.js";
import { Chip } from "../chip/chip.es.js";
import Autocomplete$1 from "../../../node_modules/@mui/material/Autocomplete/Autocomplete.es.js";
import MUITextField from "../../../node_modules/@mui/material/TextField/TextField.es.js";
function Autocomplete({
  multiple,
  ...rest
}) {
  return /* @__PURE__ */ jsx(Autocomplete$1, { multiple, popupIcon: /* @__PURE__ */ jsx(i, {}), disableCloseOnSelect: multiple, renderTags: function renderTags(tags, getTagProps) {
    return tags.map(function toChip(option, index) {
      return /* @__PURE__ */ jsx(Chip, { variant: "filled", size: "small", label: option, color: "default", ...getTagProps({
        index
      }) });
    });
  }, ...rest });
}
function AutocompleteTextField({
  ...rest
}) {
  return /* @__PURE__ */ jsx(MUITextField, { ...rest });
}
export {
  Autocomplete,
  AutocompleteTextField
};
//# sourceMappingURL=autocomplete.es.js.map
